import type { ThemeConfig } from "antd";
import { theme } from "antd";

const config: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: "#0886CF",
    colorInfo: '#ff6645',
    colorError: 'b81414',
    colorText: '#ffffff',
    boxShadow: '0 4px 24px 0 rgba(255, 255, 255, 0.1)',
    colorFillSecondary: '#000000',
  },
};

export default config;
